/* jshint esversion: 6 */
import React from 'react';
import DropDownModule from 'app/mixins/DropDownModule.js';
import * as IconFactory from 'app/components/common/IconFactory.jsx';
import ConstantMixin from 'app/mixins/ConstantMixin.js';
import classnames from 'classnames';

class ShortenerFilterItem extends React.Component {
	render() {

		var iconIndex = ConstantMixin.getIconIndexByCode(this.props.item.type, 'shortener');
		var	Icon = IconFactory[iconIndex],
			itemClass = classnames('filter-item',
				{
					'active-item': this.props.itemActive
				}
			);

        if (this.props.item.type === '') {
            Icon = IconFactory.customShortener;
        }

		return (
			<li key={this.props.key} className={itemClass} onTouchStart={this.props.onClick} onClick={this.props.onClick}>
				<div className="filter-icon">
					<Icon key={this.props.item.type} />
				</div>
				<div className="filter-label">
					{this.props.item.name}
				</div>
				<div className="filter-count">
					{this.props.item.count}
				</div>
			</li>
		);
	}
};

export default DropDownModule(ShortenerFilterItem);
